import {Button, ButtonGroup, closeCurrentDialog} from 'platform/components';
import {Show, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {PkwEnvkvAdvertisingFeedback} from '../PkwEnvkvAdvertisingFeedback/PkwEnvkvAdvertisingFeedback';

export interface PkwEnvkvAdvertisingPreflightDialogProps {
  variant: 'warning' | 'blocked';
  vehicleId: string;
  issueCodes: string[];
  onContinue?: () => void;
}

export function PkwEnvkvAdvertisingPreflightDialog(props: PkwEnvkvAdvertisingPreflightDialogProps) {
  const continuePublishing = () => {
    props.onContinue?.();
    closeCurrentDialog();
  };

  return (
    <VStack spacing={4}>
      <PkwEnvkvAdvertisingFeedback
        variant={props.variant}
        vehicleId={props.vehicleId}
        issueCodes={props.issueCodes}
        onNavigate={closeCurrentDialog}
      />
      <ButtonGroup align="right">
        <Button
          variant="secondary"
          title={i18n.t('general.actions.cancel')}
          onClick={closeCurrentDialog}
        />
        <Show when={props.variant === 'warning'}>
          <Button
            variant="primary"
            title={i18n.t('general.actions.continue')}
            onClick={continuePublishing}
          />
        </Show>
      </ButtonGroup>
    </VStack>
  );
}
